import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Clipboard} from '@angular/cdk/clipboard';

@Component({
  selector: 'ms-group-creation-return-dialog',
  templateUrl: './group-creation-return-dialog.component.html',
  styleUrls: ['./group-creation-return-dialog.component.scss'],
  standalone: false
})
export class GroupCreationReturnDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<GroupCreationReturnDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard,
    private snack: MatSnackBar
  ) {

  }

  public onClose() {
    this.dialogRef.close();
  }

  public copy(text: string) {
    this.clipboard.copy(text ?? '');
    this.snack.open('Copié dans le presse-papier', 'OK', {duration: 1500});
  }

}
